export default __webpack_public_path__ + "static/media/diagram_tree.932be3ef.svg";